export const EXCLUDE_API_LOADER = [
  'api/learning/',
  'api/connectome-feed/getStock/',
  'api/',
  'api/connectome/people/getImage',
  'api/connectome/updated/get/',
  'api/connectome/network/updated/get/',
];

export const FILE_TYPE = {
  EXCEL: ['csv', 'xlsx', 'xls'],
  IMAGE: ['jpg', 'png', 'jpeg', 'svg'],
  COMPRESSED: ['zip', 'rar'],
  PPT: ['ppt', 'pptx'],
  DOC: ['doc', 'docx'],
  PDF: ['pdf'],
};

export const CHAT_SETTING = { researchMode: 'quick', llmModel: 'none', dataSources: ['BASIC'] };

// IF HAVE ANY CHANGE, MUST TELL HUNGNK TO UPDATE IN BACKEND AND IN modal-create-agent.component.ts
export const ASK_TYPES = [
  { text: 'cdHome.t6', value: 'quick', description: 'cdHome.t7' },
  { text: 'cdHome.t8', value: 'deep', description: 'cdHome.t10' },
];

// IF HAVE ANY CHANGE, MUST TELL HUNGNK TO UPDATE IN BACKEND AND IN modal-create-agent.component.ts
export const LLM_MODELS = [
  { text: 'cdHome.t193', value: 'none', description: 'cdHome.t194' },
  { text: 'cdHome.t12', value: 'luxia_2_5', description: 'cdHome.t13' },
  { text: 'cdHome.t14', value: 'gpt_4o_mini', description: 'cdHome.t15' },
  { text: 'cdHome.t99', value: 'gpt_4o', description: 'cdHome.t15', plan: 'cdHome.t9' },
  { text: 'cdHome.t100', value: 'gpt_o3_mini', description: 'cdHome.t15', plan: 'cdHome.t9' },
  { text: 'cdHome.t102', value: 'claude_3_7_sonet', description: 'cdHome.t17', plan: 'cdHome.t9' },
  { text: 'cdHome.t16', value: 'gemini_2_flash', description: 'cdHome.t17', plan: 'cdHome.t9' },
  { text: 'cdHome.t101', value: 'gpt_o1', description: 'cdHome.t15', plan: 'Ultra' },
  { text: 'cdHome.t103', value: 'claude_3_opus', description: 'cdHome.t17', plan: 'Ultra' },
  { text: 'cdHome.t192', value: 'dall_e_3', description: 'cdHome.t192' },
];

// IF HAVE ANY CHANGE, MUST TELL HUNGNK TO UPDATE IN BACKEND AND IN modal-create-agent.component.ts
export const ASK_DATA_SOURCES = [
  { text: 'cdHome.t19', value: 'BASIC', description: 'cdHome.t20' },
  { text: 'cdHome.t21', value: 'FINANCE', description: 'cdHome.t22' },
  { text: 'cdHome.t23', value: 'RND', description: 'cdHome.t24' },
  { text: 'cdHome.t25', value: 'PATENT', description: 'cdHome.t26' },
  { text: 'cdHome.t27', value: 'LAW', description: 'cdHome.t28' },
];

// export const UPLOAD_FILE_SUPPORT = ['.xlsx', '.xls', '.doc', '.docx', '.ppt', '.pptx', '.pdf'];
export const UPLOAD_FILE_SUPPORT = ['.doc', '.docx', '.ppt', '.pptx', '.pdf'];

export const MINI_MAP_BACKGROUND_COLOR = '#ffffff';
export const SIZE_NODE_IN_MAP = {
  ROOT: 0,
  MAIN_TOPIC: 50,
  TOPIC: 25,
  CLUSTER: 15,
  BLACK_ENTITY: 1,
  ENTITY: 5,
};

export const FONTSIZE_NODE_IN_MAP = {
  ROOT: 0,
  MAIN_TOPIC: 24,
  CLUSTER: 20,
  TOPIC: 18,
  BLACK_ENTITY: 5,
  ENTITY: 12,
};

export const FONTCOLOR_NODE_IN_MAP = {
  BLACK_ENTITY_STROKE: '#cacaca',
  BLACK_ENTITY: '#212121',
  COMMON_STROKE: '#000000',
  COMMON: '#ffffff',
};

export enum TYPE_VERTEX {
  CLUSTER = 'CLUSTER',
  BLACK_ENTITY = 'BLACK_ENTITY',
  ENTITY = 'ENTITY',
  ROOT = 'ROOT',
}

export function getVertexTypeInNetwork(elementType: string) {
  switch (elementType) {
    case TYPE_VERTEX.CLUSTER:
      return TYPE_VERTEX.CLUSTER;
    case TYPE_VERTEX.ENTITY:
      return TYPE_VERTEX.ENTITY;
    case TYPE_VERTEX.BLACK_ENTITY:
      return TYPE_VERTEX.BLACK_ENTITY;
    case TYPE_VERTEX.ROOT:
      return TYPE_VERTEX.ROOT;
    default:
      return TYPE_VERTEX.BLACK_ENTITY;
  }
}

export function getVertexSizeInNetwork(elementType: string) {
  switch (elementType) {
    case TYPE_VERTEX.CLUSTER:
      return SIZE_NODE_IN_MAP.CLUSTER;
    case TYPE_VERTEX.ENTITY:
      return SIZE_NODE_IN_MAP.ENTITY;
    case TYPE_VERTEX.BLACK_ENTITY:
      return SIZE_NODE_IN_MAP.BLACK_ENTITY;
    case TYPE_VERTEX.ROOT:
      return SIZE_NODE_IN_MAP.ROOT;
    default:
      return SIZE_NODE_IN_MAP.BLACK_ENTITY;
  }
}

export function getVertexFontSizeInNetwork(elementType: string) {
  switch (elementType) {
    case TYPE_VERTEX.CLUSTER:
      return FONTSIZE_NODE_IN_MAP.CLUSTER;
    case TYPE_VERTEX.ENTITY:
      return FONTSIZE_NODE_IN_MAP.ENTITY;
    case TYPE_VERTEX.BLACK_ENTITY:
      return FONTSIZE_NODE_IN_MAP.BLACK_ENTITY;
    case TYPE_VERTEX.ROOT:
      return FONTSIZE_NODE_IN_MAP.ROOT;
    default:
      return FONTSIZE_NODE_IN_MAP.BLACK_ENTITY;
  }
}

export const FILE_TYPE_UPLOAD = {
  URL: 'URL',
  FILE: 'FILE',
  DOWNLOAD: 'DOWNLOAD',
  WEB: 'WEB',
};

export const DATA_FAKE = [
  { key: 1, value: 'a' },
  { key: 2, value: 'b' },
];

export enum GOOGLE_CONFIG {
  CLIENT_ID = '282196142246-bmgl02ms6oohg6r2rslsvuui721se15e.apps.googleusercontent.com',
  API_KEY = 'AIzaSyAEggr0yC_XlgbAykZpKPJk4KSOHvhQf9Q',
  APP_ID = '282196142246',
  DISCOVERY_DOCS = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
  SCOPES = 'https://www.googleapis.com/auth/drive.readonly',
  MIME_TYPES_SUPPORT = 'application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf',
}

export const PAGE = {
  FEED: { name: 'Scrape', link: '/scrap' },
  PEOPLE: { name: 'People', link: '/people' },
  SIGNALS: { name: 'Signal', link: '/signals' },
  CONNECTOME: { name: 'My Connectome', link: '/my-ai/connectome/2dnetwork' },
  MYAI: { name: 'My AI', link: '/my-ai/learning-center' },
  DISCOVERY: { name: 'Discovery', link: '/discovery' },
};

export const SESSION_STORAGE_CONSTANTS = {
  FEED_STATUS_TRAINING: 'FEED_STATUS_TRAINING',
  WEATHER: 'WEATHER',
};

export const LOCAL_STORAGE_CONSTANTS = {
  IP: 'IP',
  LOCALE: 'locale',
};

export const DOCUMENT_TYPE = {
  FEED: 'Feed',
  PEOPLE: 'People',
  PERSONAL_DOCUMENT: 'PersonalDocument',
};

export function getCurrentTimeZoneOffset() {
  try {
    const d = new Date().getTimezoneOffset();
    const minutes = Math.abs(d) % 60;
    const hours = Math.floor(Math.abs(d) / 60);
    const calculation = d > 0 ? '-' : '+';
    return `${calculation}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  } catch (error) {
    return '+00:00';
  }
}

//utc +0
import moment from 'moment';

export function cvLocaldateToUtcDate(localDate: Date) {
  return moment(new Date(localDate.getTime() + new Date().getTimezoneOffset() * 60000)).format('yyyyMMDD');
}

export class ResponseCode {
  public static readonly SUCCESS_CODE: string = '000';
  public static readonly FAIL_CODE: string = '044';
}

export class Setting {
  public static readonly DEFAULT_SETTING: any = {
    language: 'US',
    weather: {
      showWeatherCard: true,
      alwaysDetectLocation: true,
      temperatureUnit: 'C',
    },
    stock: {
      showStockCards: true,
      cardStyle: 'View by chart',
    },
  };
}

export const TEMPERATURE_UNIT = {
  F: 'imperial',
  C: 'metric',
};

export const CHART_STOCK_STYLE = {
  LIST: 'View by list',
  CHART: 'View by chart',
};

export const COLLECTION_SERVER = 'http://192.168.9.181:8081/';
export const ADMIN_TOOL_LINK = 'http://192.168.9.224:8081/';
export const BOARD_LINK = 'http://192.168.9.224:8082/';

export const CONVERSATION_ROLE = {
  USER: 'user',
  ASSISTANT: 'assistant',
  DATE: 'date',
};

export const DISCOVERY_VIEWS_PAGES = {
  HOME: 'home',
  SCRAPE: 'scrape',
  DISCOVERY: 'discovery',
  COMPANY: 'company',
  BRIEFING: 'briefing',
};

export const PAGES = {
  HOME: 'home',
  BRIEFING: 'briefing',
  MY_CREATE: 'myCreate',
  REPORT_DETAIL: 'report',
  DISCOVERY_DETAIL: 'detail',
  COMPANY_BRIEFING: 'company',
  COMPANY_BRIEFING_WIDGET: 'companyWidget',
  RESOURCE: 'resource',
  SOCIAL_BRIEFING: 'social',
};

export enum BriefingType {
  DISCOVERY = 'briefing.filter.discovery',
  REPORT = 'briefing.filter.report',
}

export enum ContentType {
  MYCONTENT = 'briefing.filter.my-content',
  SOCIALCONTENT = 'briefing.filter.social-content',
}

export enum OwnerType {
  ALL = 'briefing.filter.all',
  MYCONTENT = 'briefing.filter.my-content',
  SOCIALCONTENT = 'briefing.filter.social-content',
}

export enum HomeBriefingType {
  DISCOVERY = 'briefing.filter.discovery',
  REPORT = 'briefing.filter.report',
}

export enum SmartBrContentType {
  ALL = 'contentType.smartBriefing.all',
  COMPANY = 'contentType.smartBriefing.company',
  TOPIC_SUMMARY = 'contentType.smartBriefing.topicSummary',
  REPORT = 'contentType.smartBriefing.insightReport',
  VIDEO = 'contentType.smartBriefing.video',
}

export enum SmartFeedContentType {
  ALL = 'contentType.smartFeed.all',
  DISCOVERY = 'contentType.smartFeed.article',
  DOCUMENT = 'contentType.smartFeed.document',
  SOCIAL = 'contentType.smartFeed.social',
}

export enum DateOptions {
  DEFAULT = 'filter.timeRange.default',
  ALL = 'filter.timeRange.all',
  ONE_DAY = 'filter.timeRange.1day',
  ONE_WEEK = 'filter.timeRange.1week',
  ONE_MONTH = 'filter.timeRange.1month',
  THREE_MOTHNS = 'filter.timeRange.3months',
  SIX_MOTHNS = 'filter.timeRange.6months',
  ONE_YEAR = 'filter.timeRange.1year',
  SELECT = 'filter.timeRange.choose',
}

export const SmartBriefingDocumentType = ['REPORT', 'COMPANY', 'TOPIC_SUMMARY', 'VIDEO'];
export const SmartFeedDocumentType = ['DISCOVERY', 'SOCIAL', 'DOCUMENT'];
export const CompanyBriefingPage = ['COMPANY_BRIEFING_PAGE'];
export const BriefingPage = ['BRIEFING_PAGE'];
export const RecommendPage = ['RECOMMENDATION_PAGE'];

export const enumToArray = (data, context) => {
  return Object.keys(data)
    .filter(key => Number.isNaN(+key))
    .map(key => ({
      key,
      value: context.$t(data[key]),
    }));
};

export const dateFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

export enum OwnerTypeForGuest {
  ALL = 'briefing.filter.all',
  SOCIALCONTENT = 'briefing.filter.social-content',
}
